import React, { useEffect, useState } from 'react';
import { AdminVoucherDto, AdminVoucherRequestDto } from 'services/data-contracts';
import { FormFieldType, useModelStateContext } from 'saladsoft-primitive';

import { useStoreWrapper } from 'stores/StoreHelper';
import { toast } from 'react-toastify';
import SaladForm from '../tables/SaladForm';
import { DatePicker } from 'components/commons/DatePicker';
import { DateRangePicker } from 'components/commons/DateRangePicker';
import AllListings from 'components/pages/management/AllListings';
import ServiceHelper from 'stores/ServiceHelper';

interface AdminVoucherRequestModel extends AdminVoucherRequestDto {
  usePeriod?: boolean;
  period?: string[];
}
const VoucherEdit = ({
  voucher,
  categoryId,
}: {
  voucher?: AdminVoucherDto;
  categoryId?: number;
}) => {
  const { uiStore } = useStoreWrapper();
  const { setMultipleState, unmountModel } = useModelStateContext<AdminVoucherRequestModel>();

  const [isLoaded, setIsLoaded] = useState(false);

  const columns: FormFieldType<AdminVoucherRequestModel>[] = [
    {
      label: '바우처 코드',
      key: 'code',
      controlType: 'text',
      validation: 'required',
      group: { id: 'name', groupSeq: 1, seq: 1 },
    },
    {
      label: '바우처 유형',
      key: 'discountType',
      controlType: 'select',
      defaultIndex: 0,
      options: [
        { label: '할인율', value: 'PERCENT' },
        { label: '할인금액', value: 'FIXED' },
      ],
      validation: 'required',
      group: { id: 'voucherType', groupSeq: 2, seq: 1 },
    },

    {
      label: '할인율',
      key: 'price',
      controlType: 'number',
      dependsOn: 'discountType',
      dependsOnValue: 'PERCENT',
      group: { id: 'voucherType', groupSeq: 2, seq: 2 },
    },
    {
      label: '할인금액',
      key: 'price',
      controlType: 'number',
      dependsOn: 'discountType',
      dependsOnValue: 'FIXED',
      group: { id: 'voucherType', groupSeq: 2, seq: 2 },
    },
    {
      label: '발급수량',
      key: 'qty',
      controlType: 'number',
      group: { id: 'qtyGroup', groupSeq: 3, seq: 1 },
    },
    {
      label: '만료일',
      key: 'expireDate',
      controlType: 'custom',
      template: <DatePicker />,
      group: { id: 'qtyGroup', groupSeq: 3, seq: 2 },
    },

    {
      label: '숙박기간',
      key: 'usePeriod',
      controlType: 'select',
      defaultIndex: 0,
      options: [
        { label: '적용', value: 'APPLY' },
        { label: '미적용', value: 'NOT_APPLY' },
      ],
      group: { id: 'name', groupSeq: 4, seq: 1 },
    },
    {
      label: '기간',
      key: 'period',
      controlType: 'custom',
      template: <DateRangePicker />,
      dependsOn: 'usePeriod',
      dependsOnValue: 'APPLY',
      group: { id: 'type', groupSeq: 4, seq: 2 },
    },
    {
      label: '비고',
      key: 'remark',
      controlType: 'text',
      group: { id: 'remark', groupSeq: 5, seq: 1 },
    },
    {
      label: '대상 숙소',
      key: 'listingIds',
      controlType: 'custom',
      template: <AllListings />,
      group: { id: 'type', groupSeq: 6, seq: 3 },
    },
  ];

  const values = {
    discountType: 'PERCENT' as const,
  };

  const handleUpdate = async (model?: AdminVoucherRequestModel) => {
    if (!model) {
      return;
    }
    const newModel = { ...model };
    delete newModel.usePeriod;
    newModel.stayStartDate = model.period?.[0];
    newModel.stayEndDate = model.period?.[1];
    let result;
    if (voucher?.id) {
      result = await ServiceHelper.adminVoucherService?.updateVoucher(
        categoryId as number,
        voucher?.id,
        newModel as AdminVoucherRequestDto,
      );
    } else {
      if (categoryId) {
        result = await ServiceHelper.adminVoucherService?.createVoucher(
          categoryId as number,
          newModel as AdminVoucherRequestDto,
        );
      } else {
        toast.warning('바우처 카테고리가 바르지 않습니다');
      }
    }
    if (result?.status === 200) {
      toast.success(`바우처가 ${voucher?.id ? '수정' : '추가'}되었습니다.`);
      uiStore?.modal.confirm();
    } else {
      const newResult = result as any;

      toast.error(newResult?.error?.data?.errorCode);
    }
  };

  useEffect(() => {
    if (isLoaded) {
      return;
    }
    if (voucher) {
      const newModel = { ...voucher };
      const period = [newModel.stayStartDate, newModel.stayEndDate].filter(
        (date): date is string => date !== undefined,
      );
      const listingIds = newModel.listings
        ?.map((l) => l.id)
        .filter((id): id is number => id !== undefined);
      setMultipleState({ ...newModel, period, listingIds });
      setIsLoaded(true);
    }
    return () => {
      unmountModel();
    };
  }, [voucher]);

  return (
    <div style={{ paddingBottom: 40, padding: 20 }}>
      <div>
        <SaladForm fields={columns} onSave={handleUpdate} values={values} />
      </div>
    </div>
  );
};

export default VoucherEdit;
